var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-email',{ref:"dialog",attrs:{"isLoading":_vm.isLoading,"contentKey":_vm.contentKey,"contentMap":_vm.contentData,"data":_vm.data},on:{"on-submit-email":_vm.handlerSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }